import React from 'react';
import { Button, Card, Divider, Grid, Header, Message, Modal, Segment } from 'semantic-ui-react';
import { findDocumentType } from '../utils/documentTypes';
import DocumentPreview from './DocumentPreview';

class VerificationForm extends React.Component {
  constructor(props) {
    super(props)
    this.handleRef = this.handleRef.bind(this)
  }
  state = { isModalOpened: false, modalImage: null }
  documentFormRefs = {}

  closeModal = () => this.setState({ isModalOpened: false });

  openModal = (document) => this.setState({ isModalOpened: true, shownDocument: document })

  handleBack = () => this.props.history.goBack()

  handleNextClick = () => {
    const documentFormRefs = this.documentFormRefs
this.props.documents.forEach((document) => {
      if (document.type) {
        const form = documentFormRefs[document.id]
        form && form.validateForm()
      }
    })

    setTimeout(() => {
      const isValid = this.props.documents.map((document) => {
        const form = documentFormRefs[document.id]
        if (!document.type || !form) return true
        return form.props.isValid || !form.props.dirty
      }).every((validationResult) => {
        return validationResult
      })
      if (isValid) {
        this.props.onNextClick()
      }
    }, 0)
  }

  handleChange = (documentId, name, value) => {
    this.props.onDataChange(documentId, name, value)
  }

  render = () => {
    return (
      <Segment basic loading={this.props.loading}>
        <Modal
          basic
          open={this.state.isModalOpened}
          dimmer={true}
          closeIcon
          onClose={this.closeModal}
          size='fullscreen'
          content={<DocumentPreview document={this.state.shownDocument} />}
        />
        <Card.Description>
          <Grid
            verticalAlign='middle'
            centered
            columns={2}
          >
            {this.renderForms()}
            <Grid.Row columns={1}>
              <Grid.Column floated='left'>
                <Header>Passenger comment</Header>
                {this.props.claim.passengerComment ?
                  this.props.claim.passengerComment :
                  <Message>There is no passenger comment</Message>
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
        <Divider hidden />
        {this.renderWarningLabel()}
        <Card.Content extra >
          <Button positive floated="right" onClick={this.handleNextClick.bind(this)}>Next</Button>
          <Button floated="right" onClick={() => this.props.history.goBack()} >Back</Button>
        </Card.Content>
      </Segment>
    )
  }

  renderWarningLabel = () => {
    const claim = this.props.claim
    if(claim.crmState === 'a4_documents_checked' && this.props.senderType === 'pax') {
      return (
        <Message warning style={{textAlign:'center'}}>
        Completing this task will result in generating SendLOA task
        </Message>
      )
    }
    return null
  }

  renderForms() {
    if(this.props.documents.length === 0) {
      return (
        <Grid.Row columns={1}>
          <Grid.Column floated='left'>
            <Header>No attachments</Header>
          </Grid.Column>
        </Grid.Row>
      )
    }
    return this.props.documents.map((document) => {
      const flight = this.props.claim ? this.props.claim.flight : {}
      const passengerTicket = document.claimsPassengerTicket.passengerTicket
      const FormComponent = this.formComponentForDocument(document)
      const form = FormComponent !== undefined ? (
        <FormComponent
          formValues={this.props.values[document.id]}
          onDataChange={this.handleChange}
          documentId={document.id}
          onRef={this.handleRef}
          passengerTicket={passengerTicket}
          flight={flight}
        />
      ) : (<Message> Missing document type </Message>)
      return (
        <Grid.Row key={document.id} columns={2} style={{ border: '1px solid lightGrey', borderRadius: '5px' }}>
          <Grid.Column textAlign="right">
            <div style={{
              padding: '4px',
              borderColor: 'lightGrey',
              borderWidth: '1px',
              borderRadius: '5px',
              borderStyle: 'solid'
            }}>
            {document.attachmentContentType === 'application/pdf' ?
              <DocumentPreview
                zoomablePDF
                document={document}
              />
              :
              <DocumentPreview
                document={document}
                onClick={this.openModal.bind(this, document)}
              />
            }
            </div>
          </Grid.Column>
          <Grid.Column>
            {form}
          </Grid.Column>
        </Grid.Row>
      )
    })
  }

  handleRef(documentId, ref) {
    this.documentFormRefs[documentId] = ref
  }
  formComponentForDocument(document) {
    return findDocumentType(document.type).formComponent
  }
}

export default VerificationForm;



// WEBPACK FOOTER //
// ./src/component/VerificationForm.js